var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".alert_svg__a_B1R1LSQE{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "alert_svg__a_B1R1LSQE",
    d: "M0 0h44v44H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "alert_svg__a_B1R1LSQE",
    d: "M10 10h24v24H10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1 16h16L9 2Zm8.727-2.211H8.273v-1.473h1.454Zm0-2.947H8.273V7.895h1.454Z",
    transform: "translate(13 13)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgAlert;